import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { DefaultButton, PrimaryButton, Stack, Label } from '@fluentui/react';
import { AppAuthContext } from '../contexts/AppAuthContext';
import { AppThemeContext } from '../contexts/AppThemeContext';

const HomePage = (props) => {
    const { customerInfo, isAuth } = useContext(AppAuthContext);
    const { theme } = useContext(AppThemeContext);

    // const myStyles = {
    //     section: {
    //         width: "100%",
    //         height: "100%",
    //         justifyContent: 'center',
    //         backgroundSize: 'cover',
    //         backgroundImage: "url(https://cdn.wallpaperhub.app/cloudcache/c/0/6/5/2/5/c065254afc55f26407062a3d28a22d5236b82699.jpg)",
    //     },
    // }
    const stackTokens = { childrenGap: 10 };

    const btnAbout_Click = () => {
        props.history.push("/about");
    }

    const btnLogin_Click = () => {
        props.history.push("/signin");
    }

    const btnBOLList_Click = () => {
        props.history.push("/bol");
    }

    return (
        <Stack horizontalAlign='center' verticalAlign='center' tokens={stackTokens} >
            <Label color={theme.palette.Label}>صفحه اصلی</Label>
            <h2>{customerInfo ? customerInfo.title : ""}</h2>
            {!isAuth && <PrimaryButton text="ورود به پرتال حمل و نقل" onClick={btnLogin_Click} iconProps={{ iconName: "SignIn" }} />}
            <DefaultButton text="درباره ما" onClick={btnAbout_Click} iconProps={{ iconName: "Info" }} />
            <DefaultButton text="لیست بارنامه ها" onClick={btnBOLList_Click} iconProps={{ iconName: "Info" }} />
        </Stack>
    )
}

export default withRouter(HomePage);